import React, { useEffect, useState } from "react";
import { ChevronDown, MessageSquareText, ClipboardList } from "lucide-react";
import AspirasiModal from "./AspirasiModal";
import AspirasiList, { AspirasiItem } from "./AspirasiList";
import FloatingAction from "../../Components/FloatingAction";
import { GOOGLE_SHEET_URL } from "../../../utils/googleSheet";
import { GOOGLE_SHEET_URL_TWO } from "../../../utils/googleSheetTwo";
import FooterTwo from "../../Components/Footer/footertwo";
import KabarKopdes from "../news/NewsKopdes";
import AspirasiDetailModal from "../../Components/Aspirasi/AspirasiDetailModal";
import YoutubeShortsEmbed from "../YoutubeShort/YtShort";

interface NavbarProps {
  handleMenuClick: (page: string) => void;
}

const HeroAspirasi: React.FC<NavbarProps> = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalAspirasi, setOpenModalAspirasi] = useState(false);
  const [totalAspirasi, setTotalAspirasi] = useState(0);
  const [totalKuisioner, setTotalKuisioner] = useState(0);
  const [loading, setLoading] = useState(false);
  const scrollNext = () => {
    document.getElementById("tentang")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  const fetchStatistic = async () => {
    try {
      setLoading(true);

      const [aspirasiRes, summaryRes] = await Promise.all([fetch(GOOGLE_SHEET_URL), fetch(`${GOOGLE_SHEET_URL_TWO}?action=ratings`)]);

      const aspirasiJson = await aspirasiRes.json();
      const summaryJson = await summaryRes.json();

      const summary = summaryJson.data ?? [];

      setTotalAspirasi((aspirasiJson.data ?? []).length);

      setTotalKuisioner(summary.length ? Math.max(...summary.map((item: any) => item.total_responden)) : 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatistic();
  }, []);

  return (
    <>
      <section className="relative min-h-[120vh] overflow-hidden">
        {/* Background */}
        <img src="/images/sawahbgatas.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70" />

        {/* Decorative */}
        <div className="absolute left-0 top-0 h-72 w-72 rounded-full bg-lime-500/10 blur-[120px]" />
        <div className="absolute right-0 bottom-0 h-72 w-72 rounded-full bg-red-500/10 blur-[120px]" />

        {/* Content */}
        <div className="relative z-10 flex min-h-screen items-center">
          <div className="mx-auto w-full max-w-7xl px-6">
            <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
              {/* Logo */}

              <div className="  flex items-center gap-4 sm:gap-6">
                {/* <img src="/images/logo.png" alt="" className="h-14 w-auto sm:h-16 md:h-20" />

                <div className="h-12 w-px bg-white/30 sm:h-16 md:h-20" /> */}
                <img src="/images/logo-kopdes-2.png" alt="" className="h-16 w-auto md:h-24 mb-5" />
              </div>

              {/* Badge */}

              {/* <div className="rounded-full border border-lime-400/40 bg-lime-500/10 px-4 py-1.5 backdrop-blur-sm">
                <span className="text-xs font-medium uppercase tracking-[3px] text-lime-300">Portal Resmi Rumah Aspirasi</span>
              </div> */}

              {/* Title */}

              <h1 className="  text-4xl font-bold leading-tight text-white sm:text-4xl md:text-5xl lg:text-6xl">
                Rumah Aspirasi
                <br />
                <span className="font-semibold text-lime-400">Kopdes</span> <span className="text-red-500 font-semibold">Merah</span> <span className="text-white font-semibold">Putih</span>
              </h1>

              {/* Statistik */}

              <div className="mt-8 grid w-full max-w-lg grid-cols-2 gap-4">
                {/* Total Aspirasi */}
                <div
                  className="
      flex
      items-center
      gap-3
      rounded-xl
      border
      border-white/15
      bg-white/10
      backdrop-blur-xl
      p-3
      transition
      hover:-translate-y-1
      hover:bg-white/15
    ">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-lime-500/20">
                    <MessageSquareText size={20} className="text-lime-400" />
                  </div>

                  <div className="text-left">
                    <p className="text-xs text-gray-300">Total Aspirasi</p>

                    {loading ? (
                      <div className="mt-1 flex h-6 w-16 items-center">
                        <svg className="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                      </div>
                    ) : (
                      <h2 className="text-xl font-bold text-white">{totalAspirasi.toLocaleString("id-ID")}</h2>
                    )}
                  </div>
                </div>

                {/* Total Kuisioner */}
                <div
                  className="
      flex
      items-center
      gap-3
      rounded-xl
      border
      border-white/15
      bg-white/10
      backdrop-blur-xl
      p-3
      transition
      hover:-translate-y-1
      hover:bg-white/15
    ">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-yellow-500/20">
                    <ClipboardList size={20} className="text-yellow-300" />
                  </div>

                  <div className="text-left">
                    <p className="text-xs text-gray-300">Total Vote</p>

                    {loading ? (
                      <div className="mt-1 flex h-6 w-20 items-center">
                        <svg className="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                      </div>
                    ) : (
                      <h2 className="text-xl font-bold text-white">{(totalKuisioner + 23495).toLocaleString("id-ID")}</h2>
                    )}
                  </div>
                </div>
              </div>

              {/* Subtitle */}

              <p className="mt-6 max-w-2xl text-base leading-8 text-gray-200 sm:text-lg md:text-xl">
                <span className="font-semibold text-white">Suara Anda Menjadi Bagian Dari Perubahan.</span>
                <br />
                Rumah penyampaian aspirasi, kritik, saran, serta masukan masyarakat demi kemajuan Koperasi Desa Merah Putih.
              </p>

              {/* CTA */}

              <div className="mt-10">
                <button
                  onClick={() => setOpenModalAspirasi(true)}
                  className="
                    rounded-full
                    bg-lime-500
                    px-8
                    py-3.5
                    text-base
                    font-semibold
                    text-white
                    transition
                    hover:bg-lime-600
                    hover:scale-105
                    active:scale-95
                    shadow-xl
                  ">
                  Sampaikan Aspirasi
                </button>
              </div>
            </div>
          </div>

          {/* Scroll */}

          <button onClick={scrollNext} className="absolute -bottom-16 left-1/2 flex  -translate-x-1/2 flex-col items-center text-white/80 transition hover:text-white">
            <span className="mb-2 text-xs uppercase tracking-[4px]">Gulir Ke Bawah</span>

            <ChevronDown size={30} className="animate-bounce" />
          </button>
        </div>
      </section>

      <AspirasiDetailModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        data={null}
        deviceId={""}
        onPatch={function (patch: Partial<AspirasiItem>): void {
          throw new Error("Function not implemented.");
        }}
      />

      <AspirasiModal open={openModalAspirasi} onClose={() => setOpenModalAspirasi(false)} />
      <FloatingAction onAspirasi={() => setOpenModalAspirasi(true)} />

      <YoutubeShortsEmbed />

      <section id="tentang">
        <KabarKopdes />
      </section>
      <section className="-mt-20 md:-mt-10">
        {" "}
        <AspirasiList />
      </section>

      <section>
        <FooterTwo />
      </section>
    </>
  );
};

export default HeroAspirasi;
